// 该文件仅存放个人信息相关的类型(账户级别)
import type { AccountStatusType } from 'types/user';

/* --------------- 账户模块信息(账户类型/开户状态/牌照/清算商等) --------------- */
// /api/v1/web/account/info接口能拿到的数据类型(拿不到开户之后的状态)
export type ApiAccountInfoStatus = 'UNACCOUNT' | 'CONTINUE' | 'INVALID' | 'AUDITING' | 'FACE' | 'CLOSED' | 'ACTIVATING';
// 关户状态： 申请中｜撤销中｜关闭成功｜打回｜撤销｜未提交申请为null
export type CloseStatus = 'PENDING' | 'REVOKING' | 'SUCCESS' | 'REJECTED' | 'REVOKE' | null;
// 牌照
export type LicenseType = 'Marsco';

export enum EntityType {
    TBUS = 'TBUS'
}

/**
 * @description 用户的当前的状态
 * UNACCOUNT = 未开户; CONTINUE =  继续开户(缺少证件); INVALID = 修改资料(被打回);
 * AUDITING = 审核中(在Bos); FACE =  人脸识别; OPENED = 已经开户成功;
 * FUNDED =  已入金; CLOSED =  账户已注销; ACTIVATING = 激活中(fd账户关户后重新激活);
 * 跟亚光确认过: REJECTED和APPROVED状态已经没有了
 */
export type UserProcessStatus = ApiAccountInfoStatus | AccountStatusType;
// customer服务中接收和返回的账户类型
export type CustomerAccountType = 'ib' | 'nd' | 'bs';
export type ClearingType = 'marsco' | 'ib';

/* --------------- 用户开户信息 --------------- */
export enum IdTypeEnum {
    DOMESTIC_IDS = 'domestic_ids', // 大陆身份证类型
    SSN_IDS = 'ssn_ids' // SSN
}

// 权限的开通状态类型: 0表示未开通, 1表示已开通
export enum OpenPermStatusEnum {
    NOT_OPENED = 0, // 未开通
    OPENED = 1 // 已开通
}

export interface CustomerInfoType {
    age: number; // 用户年龄
    birthday: string; // 出生日期
    id_no: string; // 身份证号
    id_type: IdTypeEnum;
    in_upgrade_margin_whitelist: boolean; // margin白名单，为true时，升级Margin权限不受年龄限制
    license?: LicenseType; // 牌照信息，如新加坡是SG
    account_capabilities: 'CASH' | 'MARGIN'; // 现金账户还是保证金账户
    legal_residence_country: string; // 居住国信息
    has_delivery_address: boolean; // 是否有美国邮寄地址
    enhance_perm: OpenPermStatusEnum;
}

/* --------------- 账户/认证状态等信息 --------------- */
// 人脸识别/银行卡验证等状态
export enum VerificationStatus {
    NOT_NEED = -1, // 不需要做
    UNSUBMIT, // 未提交
    PENDING, // 审核中
    SUCCESS, // 成功
    REJECTED // 拒绝
}
// /api/v1/web/account/info接口拿到的数据类型
export interface ApiWebAccountInfoType {
    // 开户成功后就没有这个字段了
    status?: {
        status: ApiAccountInfoStatus;
    };
    available_accounts: Array<{
        name: string; // 可开通账户名称
        value: CustomerAccountType; // 可开通的账户类型
        license: LicenseType; // 可开通账户牌照
        allow_singpass: boolean; // 是否允许 singpass 开户
        clearing: ClearingType; // 清算类型
    }>;
    address_status: VerificationStatus; // 地址校验状态
    face_status: VerificationStatus; // 人脸校验状态
    bank_card_status: VerificationStatus; // 银行卡校验状态
    verification_status: VerificationStatus; // 总状态
    use_singpass: boolean; // 是否是使用singpass开户
    real_name: string; // 姓名
    real_name_en: string;
    ib_username?: string; // ib的用户名
    clearing?: 'marsco' | 'ib'; // 美国只有这两个。 其他牌照clearing 为空
    br_id?: string;
    br_account_type?: string;
    ib_account?: string;
}
export interface WebAccountInfoType extends ApiWebAccountInfoType {
    processStatus: UserProcessStatus; // 用户的状态, 这里的状态最全
    processStatusCode: number; // 用户状态映射而成的数字, 只有在状态先后比较的时候才需要使用
}
